export const locale___ComPoiTimetableTableComponent = {
	'closed___day': {
		de_de: 'geschlossen',
		en_us: 'Closed',
		es_es: 'Cerrado',
		fr_fr: 'Fermé',
		it_it: 'Chiuso',
	},
};